module.exports = __webpack_public_path__ + "static/img/icon_pd_include.f250a6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/icon_pd_include.png
// module id = QyaA
// module chunks = 1